import React from 'react';
import Localize from 'react-intl-universal';

import { Field, useFormikContext } from 'formik';

import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

// eslint-disable-next-line no-unused-vars
const ContactInformationTab = ({
  titles,
  countries,
  regions,
  countriesCommunication,
  regionsCommunication
}) => {
  const { values } = useFormikContext();

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Field
            name='email'
            label={Localize.get('Booking.email') + ' *'}
            as={TextField}
            fullWidth
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            name='phone'
            label={Localize.get('Booking.phone')}
            as={TextField}
            fullWidth
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            name='mobile'
            label={Localize.get('Booking.mobile')}
            as={TextField}
            fullWidth
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            name='street'
            label={Localize.get('Booking.street') + ' *'}
            as={TextField}
            fullWidth
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            name='number'
            label={Localize.get('Booking.streetNumber') + ' *'}
            as={TextField}
            fullWidth
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            name='postCode'
            label={Localize.get('SignIn.postcode') + ' *'}
            as={TextField}
            fullWidth
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field name='city' label={Localize.get('App.city')} as={TextField} fullWidth disabled />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Field
            name='country'
            label={Localize.get('App.country')}
            as={TextField}
            fullWidth
            select
            disabled
          >
            {countries.map((country) => (
              <MenuItem key={country} value={country}>
                {country}
              </MenuItem>
            ))}
          </Field>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            name='region'
            label={Localize.get('Booking.region')}
            as={TextField}
            fullWidth
            select
            disabled
          >
            {regions.map((region) => (
              <MenuItem key={region} value={region}>
                {region}
              </MenuItem>
            ))}
          </Field>
        </Grid>
      </Grid>

      {/* Radio buttons to choose address type */}
      <FormControl component='fieldset' sx={{ mt: 4 }}>
        <FormLabel component='legend' sx={{ fontWeight: 'bold' }}>
          {Localize.get('Booking.confirmCommunicationAddress')}
        </FormLabel>
        <Field name='communicationAddressType'>
          {({ field }) => (
            <RadioGroup {...field} row>
              <FormControlLabel
                value='same'
                control={<Radio disabled />}
                label={Localize.get('Booking.communicationAddress')}
              />
              <FormControlLabel
                value='alternative'
                control={<Radio disabled />}
                label={Localize.get('Booking.alternativeCommunicationAddress')}
              />
            </RadioGroup>
          )}
        </Field>
      </FormControl>

      {/* Alternative address */}
      {values.communicationAddressType === 'alternative' && (
        <Grid container spacing={2} mt={1}>
          <Grid item xs={12}>
            <Typography variant='h6' sx={{ fontWeight: 'bold' }}>
              {Localize.get('Booking.communicationAddressHeader')}
            </Typography>
          </Grid>

          {[
            {
              name: 'title',
              label: Localize.get('Booking.title'),
              type: 'select',
              options: titles
            },
            { name: 'firstName', label: Localize.get('Booking.firstName') + ' *' },
            { name: 'lastName', label: Localize.get('Booking.lastName') },
            { name: 'email', label: Localize.get('Booking.email') },
            { name: 'mobile', label: Localize.get('Booking.mobile') },
            { name: 'phone', label: Localize.get('Booking.phone') },
            { name: 'companyName', label: Localize.get('SignIn.companyName') },
            { name: 'street', label: Localize.get('Booking.street') },
            { name: 'number', label: Localize.get('Booking.number') },
            { name: 'postCode', label: Localize.get('SignIn.postcode') },
            { name: 'city', label: Localize.get('App.city') },
            {
              name: 'country',
              label: Localize.get('App.country'),
              type: 'select',
              options: countriesCommunication
            },
            {
              name: 'region',
              label: Localize.get('Booking.region'),
              type: 'select',
              options: regionsCommunication
            }
          ].map(({ name, label, type, options }) => (
            <Grid item xs={12} sm={6} key={name}>
              <Field
                name={`alternativeCommunicationAddress.${name}`}
                label={label}
                as={TextField}
                fullWidth
                disabled
                select={type === 'select'}
              >
                {type === 'select' &&
                  options.map((opt) => (
                    <MenuItem key={opt} value={opt}>
                      {opt}
                    </MenuItem>
                  ))}
              </Field>
            </Grid>
          ))}
        </Grid>
      )}
    </>
  );
};

export default ContactInformationTab;
